
  import { defineComponent } from "vue";
  import CustomCellMixin from "../CustomCellMixin";

  export default defineComponent({
    mixins: [CustomCellMixin],
  });
